import React, { Component } from "react";
import { Route, Switch, BrowserRouter } from "react-router-dom";
import { DragDropContextProvider } from "react-dnd";
import HTML5Backend from "react-dnd-html5-backend";
import "./App.css";
// Styles
// Import Flag Icons Set
import "flag-icon-css/css/flag-icon.min.css";
// Import Font Awesome Icons Set
import "font-awesome/css/font-awesome.min.css";
// Import Simple Line Icons Set
import "simple-line-icons/css/simple-line-icons.css";
// Import Main styles for this application
import "./scss/style.scss";
// Containers
import { DefaultLayout } from "./containers";
// Pages
import { Login, Page404, Page500 } from "./views/Pages";

// Colors for datePicker
import ThemedStyleSheet from "react-with-styles/lib/ThemedStyleSheet";
import aphroditeInterface from "react-with-styles-interface-aphrodite";
import DefaultTheme from "react-dates/lib/theme/DefaultTheme";

const colors = {
  primary: "#D15050",
  primaryShade_1: "#E83E40",
  primaryShade_2: "#F35052",
  primaryShade_3: "#DE6264",
  primaryShade_4: "#FE8283",

  primary_dark: "#B14141",

  secondary: "#A23737",
};

ThemedStyleSheet.registerInterface(aphroditeInterface);
ThemedStyleSheet.registerTheme({
  reactDates: {
    ...DefaultTheme.reactDates,
    border: {
      ...DefaultTheme.reactDates.border,
      input: {
        ...DefaultTheme.reactDates.border.input,
        borderBottomFocused: `2px solid ${colors.primary_dark}`,
      },
    },
    color: {
      ...DefaultTheme.reactDates.color,
      core: {
        ...DefaultTheme.reactDates.color.core,
        primary: colors.primary,
        primary_dark: colors.primary_dark,
      },

      hoveredSpan: {
        ...DefaultTheme.reactDates.color.hoveredSpan,
        backgroundColor: colors.primaryShade_4,
        backgroundColor_active: colors.primaryShade_3,
        backgroundColor_hover: colors.primaryShade_4,
        borderColor: colors.primaryShade_3,
        borderColor_active: colors.primaryShade_3,
        borderColor_hover: colors.primaryShade_3,
        color: colors.secondary,
        color_active: colors.secondary,
        color_hover: colors.secondary,
      },

      selectedSpan: {
        ...DefaultTheme.reactDates.color.selectedSpan,
        backgroundColor: colors.primaryShade_2,
        backgroundColor_active: colors.primary,
        backgroundColor_hover: colors.primary,
        borderColor: colors.primaryShade_1,
        borderColor_active: colors.primary,
        borderColor_hover: colors.primary,
      },

      selected: {
        ...DefaultTheme.reactDates.color.selected,
        backgroundColor: colors.primary_dark,
        backgroundColor_active: colors.primary_dark,
        backgroundColor_hover: colors.primary_dark,
        borderColor: colors.primary,
        borderColor_active: colors.primary,
        borderColor_hover: colors.primary,
      },
    },
  },
});

class App extends Component {
  render() {
    return (
      <DragDropContextProvider backend={HTML5Backend}>
        <BrowserRouter>
          <Switch>
            {/* single page without its menu, header and footer page */}
            <Route exact path="/" name="Login Page" component={Login} />
            <Route exact path="/login" name="Login Page" component={Login} />
            <Route exact path="/404" name="Page 404" component={Page404} />
            <Route exact path="/500" name="Page 500" component={Page500} />
            <Route path="/" name="Home" component={DefaultLayout} />
          </Switch>
        </BrowserRouter>
      </DragDropContextProvider>
    );
  }
}

export default App;
